import type { ChangeEvent, FC, InputHTMLAttributes } from "react";
import { useEffect, useRef, useState } from "react";
import { useField } from "remix-validated-form";
import WvInput from "../atoms/WvInput";

const WvInputField: FC<
  {
    name: string;
    onChange?: (v: string) => void;
    onDefaultChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    theme?: "normal" | "error" | "valid";
    initialValue?: string | number;
    customError?: string;
    revalidateChecker?: any;
  } & Omit<InputHTMLAttributes<HTMLInputElement>, "onChange">
> = ({
  name,
  onChange,
  initialValue,
  customError,
  revalidateChecker,
  onDefaultChange,
  ...props
}) => {
  const firstRun = useRef(true);
  const [inputTheme, setInputTheme] = useState<"normal" | "error" | "valid">(
    "normal"
  );

  const { error, getInputProps, validate, clearError } = useField(name);

  useEffect(() => {
    if (customError || error) {
      setInputTheme("error");
    } else {
      setInputTheme("normal");
    }
    //UPDATE INPUT THEME AS SOON AS THERE IS ERROR
  }, [customError, error]);

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    if (revalidateChecker) {
      clearError();
      setInputTheme("normal");
    }
  }, [revalidateChecker]);

  return (
    <WvInput
      {...getInputProps({ id: name, ...props })}
      initialValue={initialValue}
      theme={inputTheme}
      onDefaultChange={onDefaultChange}
      onChange={(v) => {
        onChange?.(v as string);
        if (v) clearError();
        if (v) setInputTheme("normal");
      }}
      onBlur={(e) => {
        validate();
        setInputTheme(error ? "error" : "normal");
        //LET INPUT WITHOUT ERROR BE NORMAL (EVEN IF IT'S EMPTY)
        props?.onBlur?.(e);
      }}
    />
  );
};

export default WvInputField;
